import { render } from "./AlarmTriggersEditor.vue?vue&type=template&id=53c8f91a"
import script from "./AlarmTriggersEditor.vue?vue&type=script&lang=js"
export * from "./AlarmTriggersEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__